export enum KnownRole {
	SuperAdmin = 1,
	InternalAdmin = 2,
	InternalSupport = 3,
	PartnerAdmin = 4,
	PartnerStandard = 5,
	ManufacturerAdmin = 7,
	ManufacturerRep = 8
}

export const ManufacturerRoles = [
	KnownRole.ManufacturerAdmin,
	KnownRole.ManufacturerRep
];

export const PartnerRoles = [
	KnownRole.PartnerAdmin,
	KnownRole.PartnerStandard
];

export const InternalRoles = [
	KnownRole.SuperAdmin,
	KnownRole.InternalAdmin,
	KnownRole.InternalSupport
];
